// Duas origens, dois trabalhos.
//
// okazip.com explica o produto a quem nunca ouviu falar dele. app.okazip.com
// é o produto — é o endereço que o app iOS carrega, que o TWA do Android
// abre e que fica salvo na tela de início. Quem chega ali já sabe o que veio
// fazer, e a landing entre a pessoa e o arquivo dela é só um clique cobrado
// por nada. É a mesma separação que o WhatsApp faz entre whatsapp.com e
// web.whatsapp.com.
//
// O código é um só: um bundle servido nos dois lugares. O que muda é o que
// o portão desenha para quem ainda não entrou.

/** O endereço do app, onde não se vende nada. */
export function isAppOrigin(): boolean {
  if (typeof location === 'undefined') return false;
  const host = location.hostname;
  // O nome próprio e o nome que a Firebase dá ao mesmo site. Nada de
  // `includes('app')` — `wcloud-508914.web.app` termina em "app" e é a
  // landing.
  return host.startsWith('app.') || host === 'okazip-app.web.app';
}

/** Onde o produto é explicado, para quem chegou ao app sem saber o que é. */
export const SHOP = 'https://okazip.com/';

/** E onde se entra. A landing não autentica ninguém; encaminha para aqui. */
export const APP = 'https://app.okazip.com/';

export function goToApp(): void {
  location.assign(APP);
}
